import React from "react";
import { AlertTriangle, RefreshCw, Home } from "lucide-react";

export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        console.error("ErrorBoundary caught an error:", error, errorInfo);
    }

    handleReload = () => {
        window.location.reload();
    };

    handleHome = () => {
        window.location.href = "/";
    };

    render() {
        if (this.state.hasError) {
            return (
                <div className="min-h-screen bg-ink-900 text-white flex flex-col items-center justify-center p-6 text-center">
                    <div className="w-14 h-14 rounded-2xl bg-brand/10 border border-brand/20 flex items-center justify-center text-brand mb-6 shadow-[0_0_30px_rgba(255,69,0,0.2)]">
                        <AlertTriangle size={28} />
                    </div>
                    <h1 className="font-display text-3xl sm:text-4xl text-white tracking-tight mb-3">
                        Something went wrong
                    </h1>
                    <p className="text-ink-200 max-w-md mb-8 leading-relaxed text-sm sm:text-base">
                        An unexpected runtime issue occurred while rendering this view. Please try reloading the page or returning to the homepage.
                    </p>
                    <div className="flex flex-wrap items-center justify-center gap-3">
                        <button
                            type="button"
                            onClick={this.handleReload}
                            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-brand text-white font-medium hover:bg-brand-hover transition-colors shadow-lg"
                        >
                            <RefreshCw size={16} /> Reload Page
                        </button>
                        <button
                            type="button"
                            onClick={this.handleHome}
                            className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-white/15 text-white hover:bg-white/5 transition-colors font-medium"
                        >
                            <Home size={16} /> Return to Home
                        </button>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}
